export const isSelectedEMSAgencyAPreviousAgency = (selectedEMSAgencyId: string, previousEMSAgencies?: Array<unknown>) =>
  previousEMSAgencies?.some(previousEMSAgency => previousEMSAgency === selectedEMSAgencyId);
